module.exports = __webpack_public_path__ + "img/pen2.34683bef.png";